<template>
  <b-navbar id="navbar" toggleable="lg" type="dark" sticky>
    <transition name="fade-quick">
      <div class="container" v-if="ready">
        <!-- Gallery Tree Navigation -->
        <template v-if="isGalleryTree">
          <b-navbar-brand :to="galleryTreeBackDestination">
            <div class="d-flex align-items-center position-relative">
              <transition :name="transitionBack">
                <div class="align-items-center nav-back" v-if="showBackButton">
                  <Icon name="chevronLeft" width="34" class="mr-2"/>
                </div>
              </transition>
              <!-- Future: Add breadcrumb here -->
              <transition :name="transitionLogo">
                <div class="logo" :class="{'has-back': showBackButton}"
                     v-if="appConfigReady && (!showBackButton || showAlwaysLogo)">
                  <img :src="getAppLogo" alt="Logo">
                </div>
              </transition>
            </div>
          </b-navbar-brand>
        </template>

        <!-- Default Navigation -->
        <template v-else>
          <b-navbar-brand :to="{ name: 'checkins-list'}">
            <div class="d-flex align-items-center position-relative">
              <transition :name="transitionBack">
                <div class="align-items-center nav-back" v-if="showBackButton">
                  <Icon name="chevronLeft" width="34" class="mr-2"/>
                </div>
              </transition>

              <transition :name="transitionLogo">
                <div class="logo" :class="{'has-back': showBackButton}"
                     v-if="appConfigReady && (!showBackButton || showAlwaysLogo)">
                  <img :src="getAppLogo" alt="Logo">
                </div>
              </transition>
            </div>
          </b-navbar-brand>
        </template>

        <b-navbar-nav class="ml-auto py-0 d-flex align-items-center">
          <li class="nav-item">
            <ImpersonateBadge/>
          </li>
          <li class="nav-item">
            <FixedNotification/>
          </li>
          <li class="nav-item" v-if="!showCheckinMenu">
            <a class="nav-link nav-link--main d-flex align-items-center" href="#"
               @click.prevent="$bvModal.show('bv-modal-checkin-maker')">
              <Icon name="plusCircle" :width="30"/>
              <span class="d-none d-md-block ml-md-2 mr-md-1">{{ $t('menu.do_checkin') }}</span>
            </a>
          </li>
          <router-link tag="li" :to="{ name: 'checkout'}" v-if="showNavbarCart" custom
                       v-slot="{ href, navigate }">
            <li class="nav-item">
              <a class="nav-link nav__cart" :href="href" @click="navigate">
                <Icon name="cart" :height="18"/>
                <span class="ml-2" v-if="cartDigitalItemsTotals">
                  <template v-if="cartDigitalItemsTotal > 0">
                    {{ cartDigitalItemsTotal|formatCurrency(cartDigitalItemsCurrency) }}
                  </template>
                  <template v-else>
                    {{ $t('pages.checkout.summary_action_get_for_free') }}
                  </template>
                </span>
              </a>
            </li>
          </router-link>
          <li class="nav-item">
            <checkin-menu v-if="showCheckinMenu && checkin"
                          :checkin="checkin"
                          right
                          :icon-size="30"
                          is-checkin-detail
                          @remove-album="$bvModal.show('bv-modal-remove-checkin')"
                          @anonymize-album="$bvModal.show('modal-anonymize-checkin')"
                          @show-qr-picacode="$bvModal.show('bv-modal-show-qr-picacode')"
            />
            <main-menu v-else/>
          </li>
        </b-navbar-nav>

      </div>
    </transition>
  </b-navbar>
</template>


<script>
import ImpersonateBadge from "@/domain/impersonate/ImpersonateBadge.vue";
import {mapGetters} from "vuex";
import FixedNotification from "@/components/customEvents/FixedNotification.vue";
import MainMenu from "@/domain/core/MainMenu.vue";
import CheckinMenu from "@/domain/core/CheckinMenu.vue";

export default {
  components: {CheckinMenu, MainMenu, FixedNotification, ImpersonateBadge},
  data() {
    return {
      ready: false
    }
  },
  computed: {
    ...mapGetters('appConfig', ['appConfigReady', 'getAppLogo', 'hideCart']),
    ...mapGetters('checkinDetail', ['checkin']),
    ...mapGetters(['thirdLevelDomain']),
    ...mapGetters('cartDigitalItems', [
      'cartDigitalItemsTotals',
      'cartDigitalItemsTotal',
      'cartDigitalItemsCount',
      'cartDigitalItemsCurrency']),
    showNavbarCart() {
      return this.appConfigReady &&
          !this.hideCart &&
          this.$route.meta.showNavbarCart !== false &&
          this.cartDigitalItemsTotals &&
          this.cartDigitalItemsCount > 0
    },
    showBackButton() {
      return this.$route.meta.showBackButton
    },
    isGalleryTree() {
      return this.$route.name === 'gallery-tree'
    },
    galleryTreeBackDestination() {
      const currentGalleryId = this.$route.params.gallery_id

      // If we have a gallery_id and it's not 0, navigate to gallery 0
      if (currentGalleryId && currentGalleryId !== '0') {
        return {
          name: 'gallery-tree',
          params: {
            picacode: this.$route.params.picacode,
            gallery_id: '0'
          }
        }
      }

      // If already at gallery 0, go back to checkins list
      return { name: 'checkins-list' }
    },
    showCheckinMenu() {
      return this.$route.meta.showCheckinMenu
    },
    showAlwaysLogo() {
      return this.thirdLevelDomain === 'euroleague' || this.thirdLevelDomain === 'rctid'
    },
    transitionBack() {
      return this.showAlwaysLogo ? 'fade' : 'slide-right'
    },
    transitionLogo() {
      return this.showAlwaysLogo ? '' : 'slide-left'
    }

  },
  mounted() {
    setTimeout(() => {
      this.ready = true
    }, 1000)
  }
}
</script>
